<template>
  <v-row class="align-items-center">
    <v-col class="pa-0">
      <ErrorControls
        v-if="props.showErrorControls"
        :invalid-rows-message="tkey('mustHaveSisterProductsWarning')"
        :is-showing-invalid-rows="props.filterInvalidRows"
        class="mt-2 ml-2 d-flex"
        @click.stop="onToggleInvalidRows"
      />
      <WarningControls
        v-if="props.showWarningControls"
        :invalid-rows-message="tkey('sisterProductsWarning')"
        :is-showing-invalid-rows="props.filterWarningRows"
        class="mt-2 ml-2 d-flex"
        @click.stop="onToggleWarningRows"
      />
      <div v-if="props.needsCDT || props.notModelledProductsCount" class="mt-2 ml-2 d-flex">
        <span v-if="props.needsCDT" class="font-weight-bold text-error">
          {{ t('validationErrors.runCDT') }}
        </span>
      </div>
    </v-col>
  </v-row>
</template>

<script setup>
import { useInternationalization } from '@/composables/use-internationalization';

const props = defineProps({
  showErrorControls: Boolean,
  showWarningControls: Boolean,
  filterInvalidRows: Boolean,
  filterWarningRows: Boolean,
  needsCDT: Boolean,
  notModelledProductsCount: Number,
});
const emit = defineEmits(['toggleInvalidRows', 'toggleWarningRows']);
const { tkey, t } = useInternationalization('productModellingPage');

const onToggleInvalidRows = () => emit('toggleInvalidRows');
const onToggleWarningRows = () => emit('toggleWarningRows');
</script>
